import { Creative } from 'domains/creative';
import { CreativeResponseDTO } from 'infrastructure/dtos/creative';
import { CategoryMapper } from '../category';

export class CreativesMapper {
  static fromDTO(creativeResponseDTO: CreativeResponseDTO): Creative {
    let category;

    if (creativeResponseDTO.category) {
      category = CategoryMapper.fromDTO(creativeResponseDTO.category);
    }

    return new Creative(
      creativeResponseDTO.user_id.toString(),
      creativeResponseDTO.username,
      category,
      creativeResponseDTO.profile_image,
      creativeResponseDTO.status,
      creativeResponseDTO.timestamp,
      creativeResponseDTO.total_pending_post
    );
  }
}
